import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatYoullLearn() {
  const items = [{
    title: 'Why Some Sugars Affect The Mouth Differently Than Others',
    desc: 'Learn how different forms of sugar may interact with the oral environment and why some habits may be more impactful than you realize.'
  }, {
    title: 'The Overlooked Nighttime Habit Many People Ignore',
    desc: 'Discover a simple concept related to overnight oral conditions that many people never consider.'
  }, {
    title: 'What Researchers Are Learning About Oral Bacteria',
    desc: 'Understand the growing interest in the oral microbiome and its role in supporting a healthy mouth.'
  }, {
    title: 'Daily Practices That May Support Better Oral Wellness',
    desc: 'Explore practical habits that fit easily into your daily routine.'
  }, {
    title: 'Common Oral Health Myths That May Be Misleading',
    desc: 'Separate popular beliefs from emerging educational insights.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-287">
      <div className="max-w-4xl mx-auto px-6" data-id="element-288">
        {/* Intro */}
        <div className="text-center mb-14" data-id="element-289">
          <span className="inline-block bg-sky-100 text-sky-700 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-4" data-id="element-290">
            Educational Guide
          </span>
          <h2 className="text-2xl md:text-3xl font-playfair font-bold text-slate-900 mb-6 leading-tight" data-id="element-291">
            Based On Emerging Research Into Oral Bacteria, Sugar Exposure, And
            Everyday Dental Habits
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed mb-3" data-id="element-292">
            Discover practical insights that may help you better understand the
            relationship between sugar, oral bacteria, and long-term dental
            wellness.
          </p>
          <p className="text-slate-600 text-lg leading-relaxed" data-id="element-293">
            Designed for everyday people looking to make more informed decisions
            about their oral health.
          </p>
        </div>

        {/* Bullets */}
        <h3 className="text-2xl md:text-3xl font-playfair font-bold text-slate-900 mb-8 text-center" data-id="element-294">
          What You'll Learn Inside
        </h3>

        <div className="space-y-4 mb-10" data-id="element-295">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex items-start bg-white rounded-2xl p-5 shadow-sm border border-slate-100" data-id="element-296">
              <div className="w-9 h-9 rounded-full bg-sky-500 flex items-center justify-center mr-4 shrink-0 mt-0.5" data-id="element-297">
                <CheckIcon size={18} className="text-white" strokeWidth={3} data-id="element-298" />
              </div>
              <div data-id="element-299">
                <h4 className="font-playfair font-bold text-slate-900 text-lg mb-1 leading-snug" data-id="element-300">
                  {item.title}
                </h4>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-301">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-302">
          <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-10 rounded-full transition-all transform hover:scale-105 shadow-lg text-lg" data-id="element-303">
            Get Instant Access Now
          </button>
        </div>
      </div>
    </section>;
}